'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCoverLotsIfNeeded = exports.isCoverLotsLoading = exports.getLoadTimeForCoverLots = exports.getCoverLots = exports.LOAD_COVER_LOTS_SUCCESS = exports.LOAD_COVER_LOTS_REQUEST = exports.LOAD_COVER_LOTS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _config = require('../modules/config');

var _home = require('../modules/home');

var _upcomingCatalogs = require('../modules/upcomingCatalogs');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_COVER_LOTS_FAIL = exports.LOAD_COVER_LOTS_FAIL = 'la/domain/coverLots/LOAD_FAIL';
var LOAD_COVER_LOTS_REQUEST = exports.LOAD_COVER_LOTS_REQUEST = 'la/domain/coverLots/LOAD_REQUEST';
var LOAD_COVER_LOTS_SUCCESS = exports.LOAD_COVER_LOTS_SUCCESS = 'la/domain/coverLots/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_COVER_LOTS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.payload)
            });
        case LOAD_COVER_LOTS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_COVER_LOTS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            action.payload.forEach(function (item) {
                existing[item.catalogId] = (0, _extends3.default)({}, item);
                loaded[item.catalogId] = time;
                loading = (0, _difference2.default)(loading, [item.catalogId]);
            });
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        case _home.LOAD_HOME_DATA_SUCCESS:
        case _upcomingCatalogs.LOAD_UPCOMING_CATALOGS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.smallCoverLots) {
                action.payload.smallCoverLots.forEach(function (item) {
                    existing[item.catalogId] = (0, _extends3.default)({}, item);
                    loaded[item.catalogId] = time;
                    loading = (0, _difference2.default)(loading, [item.catalogId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.coverLots;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getCoverLots = exports.getCoverLots = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || { catalogId: 0, results: [{}, {}, {}] };
});

var getLoadTimeForCoverLots = exports.getLoadTimeForCoverLots = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isCoverLotsLoading = exports.isCoverLotsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchCoverLots = function shouldFetchCoverLots(state, catalogId) {
    if (!catalogId) return false;
    var item = getCoverLots(state, catalogId);
    if (item) {
        var loaded = getLoadTimeForCoverLots(state, catalogId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isCoverLotsLoading(state, catalogId);
    return !loading;
};

var coverLotsToFetch = function coverLotsToFetch(state, catalogIds) {
    return catalogIds.filter(function (id) {
        return shouldFetchCoverLots(state, id);
    });
};

/* ACTION CREATORS */
var loadCoverLotsFail = function loadCoverLotsFail(catalogIds, error) {
    return {
        error: true,
        meta: { catalogIds: catalogIds },
        payload: error,
        type: LOAD_COVER_LOTS_FAIL
    };
};

var loadCoverLotsRequest = function loadCoverLotsRequest(catalogIds) {
    return {
        payload: catalogIds,
        type: LOAD_COVER_LOTS_REQUEST
    };
};

var loadCoverLotsSuccess = function loadCoverLotsSuccess(catalogIds, results) {
    return {
        meta: { actionTime: Date.now(), catalogIds: catalogIds },
        payload: results,
        type: LOAD_COVER_LOTS_SUCCESS
    };
};

var loadCoverLots = function loadCoverLots(catalogIds) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(loadCoverLotsRequest(catalogIds));
        return _api.CoverLots.fetchCoverLots({ catalogIds: catalogIds, deployment: deployment }).then(function (response) {
            dispatch(loadCoverLotsSuccess(catalogIds, response.data));
        }).catch(function (error) {
            dispatch(loadCoverLotsFail(catalogIds, error));
        });
    };
};

var fetchCoverLotsIfNeeded = exports.fetchCoverLotsIfNeeded = function fetchCoverLotsIfNeeded(catalogIds) {
    return function (dispatch, getState) {
        var coverLotsToLoad = coverLotsToFetch(getState(), catalogIds);
        if (coverLotsToLoad.length) {
            return dispatch(loadCoverLots(coverLotsToLoad));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/coverLots.js
// module id = fr8l
// module chunks = 57